<template>
  <div>
    <template v-if="hasSubscriptions">
      <div v-for="(subscriptionList, dateKey) in subscriptionsGroups" :key="dateKey">
        <div class="group-header">
          {{ dateKey }}
        </div>
        <ul class="group-list">
          <subscription-item
            v-for="subscription in subscriptionList"
            :key="`${subscription.id}_${subscription.createdAt}`"
            :subscription="subscription"
            @click="onClickSubscription"
            @unfollow="id => $emit('unfollow', id)"
          />
        </ul>
      </div>
    </template>
    <div v-else class="subscription-empty-list">
      {{ $t('no.subscriptions') }}
    </div>
  </div>
</template>

<script>
import SubscriptionItem from './SubscriptionItem';

export default {
  name: 'SubscriptionsGroups',
  components: {
    SubscriptionItem,
  },
  props: {
    subscriptionsGroups: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    hasSubscriptions() {
      return this.$validate.isNotEmptyObject(this.subscriptionsGroups);
    },
  },
  methods: {
    onClickSubscription(subscription) {
      this.$router.push({
        name: 'cabinet',
        query: {
          subscriberId: subscription.id,
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .subscription-empty-list
    padding: 0 20px

  .group-header
    margin-left: 1rem
    font-weight: 500
    font-size: 14px
    line-height: 40px
    color: #fff
    opacity: 0.25

    +respond-to('medium')
      margin-left: 0
</style>
